import React from "react";
import {EssentialsTab} from "../../common/EssentialsTab";

const PortugalEssentialTab = () => {
    return (
        <EssentialsTab context={{
            items: 'portugal_essential_items',
        }}/>
    );
}

export default PortugalEssentialTab;
